var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3037 8.01535L6.71733 12.7546C6.4007 13.0818 5.88735 13.0818 5.57072 12.7546C5.2541 12.4274 5.2541 11.897 5.57072 11.5698L9.04015 7.98475L5.60023 4.4302C5.2836 4.10302 5.2836 3.57256 5.60023 3.24538C5.91686 2.91821 6.43021 2.91821 6.74683 3.24538L11.3333 7.98465L11.3036 8.01525L11.3037 8.01535Z",
    fill: "#AFBACC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowClose);
export default __webpack_public_path__ + "static/media/ic_arrow_close.9d37754a.svg";
export { ForwardRef as ReactComponent };